import { COUNTRY, HrefLangListType, LANGUAGE } from "@type/index";
import { convertRegionName } from "@util/country";
import { findStrIndex } from "@util/helpers";
import store from "../../redux/store";

export const getHrefLangList = (endPath: string): HrefLangListType[] => {
  const { region, language } = store.getState().config;
  const _index = findStrIndex(endPath, "/", 2);
  const _path = endPath.slice(_index + 1);
  let hrefLang: HrefLangListType[] = [];
  switch (region) {
    case COUNTRY.FR:
      hrefLang = [
        {
          hrefLang: "fr-fr",
          alternateHref: [COUNTRY.FR, LANGUAGE.FR, _path].join("/")
        },
        {
          hrefLang: "en-fr",
          alternateHref: [COUNTRY.FR, LANGUAGE.EN, _path].join("/")
        }
      ];
      break;
    case COUNTRY.DE:
      hrefLang = [
        {
          hrefLang: "de-de",
          alternateHref: [COUNTRY.DE, LANGUAGE.DE, _path].join("/")
        },
        {
          hrefLang: "en-de",
          alternateHref: [COUNTRY.DE, LANGUAGE.EN, _path].join("/")
        }
      ];
      break;
    case COUNTRY.ES:
      hrefLang = [
        {
          hrefLang: "es-es",
          alternateHref: [COUNTRY.ES, LANGUAGE.ES, _path].join("/")
        },
        {
          hrefLang: "en-es",
          alternateHref: [COUNTRY.ES, LANGUAGE.EN, _path].join("/")
        }
      ];
      break;
    case COUNTRY.IT:
      hrefLang = [
        {
          hrefLang: "it-it",
          alternateHref: [COUNTRY.IT, LANGUAGE.IT, _path].join("/")
        },
        {
          hrefLang: "en-it",
          alternateHref: [COUNTRY.IT, LANGUAGE.EN, _path].join("/")
        }
      ];
      break;
    case COUNTRY.NL:
      hrefLang = [
        {
          hrefLang: "nl-nl",
          alternateHref: [COUNTRY.NL, LANGUAGE.NL, _path].join("/")
        },
        {
          hrefLang: "en-nl",
          alternateHref: [COUNTRY.NL, LANGUAGE.EN, _path].join("/")
        }
      ];
      break;
    case COUNTRY.BE:
      hrefLang = [
        {
          hrefLang: "fr-be",
          alternateHref: [COUNTRY.BE, LANGUAGE.FR, _path].join("/")
        },
        {
          hrefLang: "nl-be",
          alternateHref: [COUNTRY.BE, LANGUAGE.NL, _path].join("/")
        },
        {
          hrefLang: "en-be",
          alternateHref: [COUNTRY.BE, LANGUAGE.EN, _path].join("/")
        }
      ];
      break;
    case COUNTRY.CA:
      hrefLang = [
        {
          hrefLang: "en-ca",
          alternateHref: [COUNTRY.CA, LANGUAGE.EN, _path].join("/")
        },
        {
          hrefLang: "fr-ca",
          alternateHref: [COUNTRY.CA, LANGUAGE.FR, _path].join("/")
        }
      ];
      break;
    case COUNTRY.ID:
      hrefLang = [
        {
          hrefLang: "en-id",
          alternateHref: [COUNTRY.ID, LANGUAGE.EN, _path].join("/")
        },
        {
          hrefLang: "id-id",
          alternateHref: [COUNTRY.ID, LANGUAGE.ID, _path].join("/")
        }
      ];
      break;
    case COUNTRY.TH:
      hrefLang = [
        {
          hrefLang: "en-th",
          alternateHref: [COUNTRY.TH, LANGUAGE.EN, _path].join("/")
        },
        {
          hrefLang: "th-th",
          alternateHref: [COUNTRY.TH, LANGUAGE.TH, _path].join("/")
        }
      ];
      break;
    case COUNTRY.VN:
      hrefLang = [
        {
          hrefLang: "en-vn",
          alternateHref: [COUNTRY.VN, LANGUAGE.EN, _path].join("/")
        },
        {
          hrefLang: "vi-vn",
          alternateHref: [COUNTRY.VN, LANGUAGE.VI, _path].join("/")
        }
      ];
      break;
    default:
      hrefLang = [
        {
          hrefLang: `${language}-${convertRegionName(region)}`,
          alternateHref: [region, language, _path].join("/")
        }
      ];
      break;
  }
  return hrefLang;
};
